import './ChartLegend.scss';
import { Icons, Status, Tooltip } from 'plume-ui';
import React, { memo } from 'react';
import { AdjustableComponent } from '../../../../utils/hooks/useClasses';

export type ChartLegendProps = {
  items: {
    label: string;
    tooltipText?: string;
    stroke: string;
  }[];
};

type ChartLegendStyles = {};

const ChartLegend: AdjustableComponent<ChartLegendProps, ChartLegendStyles> = ({
  items,
}) => {
  return (
    <span className="ChartLegend">
      {items.map((item) => (
        <div key={item.label} className="ChartLegend__item">
          <Status variant="legend" color={item.stroke} label={item.label} />
          {item.tooltipText !== undefined && (
            <Tooltip
              position="above"
              heading={item.label}
              label={item.tooltipText}
              openInPortal
            >
              <Icons.InfoIcon width={16} className="HealthSummary__InfoIcon" />
            </Tooltip>
          )}
        </div>
      ))}
    </span>
  );
};

export default memo(ChartLegend);
